export const BlindsUp = () => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-25%"
        y="-14.4%"
        width="150%"
        height="151.1%"
        filterUnits="objectBoundingBox"
        id="f1vp39gwsa"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect id="7c6768ibab" x="1.408" y="2" width="46" height="45" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(5)">
        <use fill="#000" filter="url(#f1vp39gwsa)" xlinkHref="#7c6768ibab" />
        <use fill="#FFF" xlinkHref="#7c6768ibab" />
      </g>
      <path
        d="M29 25.136 41.5 33v-7.11L29 18h.028L16.5 25.89V33l12.528-7.864"
        fill="#2396FD"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
